var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var MapConfigurationService = /** @class */ (function (_super) {
            __extends(MapConfigurationService, _super);
            function MapConfigurationService(injectedBreeze, $q, $http) {
                var _this = _super.call(this, injectedBreeze, $q) || this;
                _this.$http = $http;
                return _this;
            }
            MapConfigurationService.prototype.getMapConfigurations = function () {
                var query = this.breezeModule.EntityQuery
                    .from("MapConfigurations")
                    .expand('mapFunctions, gisActionWorkflowConfigurations, queryGridConfigurations')
                    .orderBy("name");
                return this.executeQuery(query);
            };
            MapConfigurationService.prototype.getLayerConfigurations = function (mapConfigurationId) {
                var query = this.breezeModule.EntityQuery
                    .from("Layers")
                    .where('mapConfiguration_id', '==', mapConfigurationId)
                    .orderBy("name");
                return (this.executeQuery(query));
            };
            MapConfigurationService.prototype.getMapConfiguration = function (id) {
                var d = this.$q.defer();
                var query = this.breezeModule.EntityQuery
                    .from("MapConfigurations")
                    .where('id', '==', id)
                    .expand("layers.esriMapServiceMetadata.layers.fields," +
                    "javascriptTransformers," +
                    "gisActionWorkflowConfigurations.gisActionBlocks," +
                    "gisActionWorkflowConfigurations.gisActionBlocks.setPropertyConfiguration," +
                    "gisActionWorkflowConfigurations.gisActionBlocks.gisActionValidationConfiguration," +
                    "gisActionWorkflowConfigurations.gisActionBlocks.bufferConfiguration," +
                    "gisActionWorkflowConfigurations.gisActionBlocks.inputCollection.gisInputOutputs.relatedGisInputOutput," +
                    "gisActionWorkflowConfigurations.gisActionBlocks.outputCollection.gisInputOutputs.relatedGisInputOutput," +
                    "gisActionWorkflowConfigurations.gisActionBlocks.drawFeatureConfiguration.drawStyle," +
                    "gisActionWorkflowConfigurations.gisActionBlocks.trimConfiguration.lineTrimAttributes," +
                    "gisActionWorkflowConfigurations.gisActionBlocks.gisActionBlockEsriQueryConfiguration, " +
                    "gisActionWorkflowConfigurations.gisActionBlocks.filterFeatureCollectionConfiguration.filterAttributes, " +
                    "gisActionWorkflowConfigurations.gisActionBlocks.addFeaturesConfiguration.featureAttributeToPropertyMaps, " +
                    "queryGridConfigurations.queryGridQueries.gisFieldMappings.includedQueryField, " +
                    "queryGridConfigurations.includedQueryFields, " +
                    "queryGridConfigurations.drawStyle, " +
                    "esriQueryConfigurations.wherePredicates, " +
                    "esriQueryConfigurations.geometryFilter, " +
                    "gisDatastoreQueryConfigurations.wherePredicates, " +
                    "gisDatastoreQueryConfigurations.geometryFilter, " +
                    "legendConfigurations.legendLayers," +
                    "mapFunctions.drawFeatureConfiguration.drawStyle," +
                    "mapFunctions.zoomToQueryConfiguration.placeHolderForInput ");
                this.executeQuery(query).then(function (r) {
                    d.resolve(r[0]);
                });
                return d.promise;
            };
            MapConfigurationService.prototype.createMapConfiguration = function () {
                return this.createNewEntity("MapConfiguration");
            };
            MapConfigurationService.prototype.createGisWherePedicate = function () {
                return this.createNewEntity("GisWherePredicate");
            };
            MapConfigurationService.prototype.createLayer = function () {
                return this.createNewEntity("Layer");
            };
            MapConfigurationService.prototype.createMapFunctionConfiguration = function () {
                return this.createNewEntity("MapFunctionConfiguration");
            };
            MapConfigurationService.prototype.createEsriQueryConfiguration = function () {
                return this.createNewEntity("EsriQueryConfiguration");
            };
            MapConfigurationService.prototype.createEsriPlaceHolderValue = function () {
                return this.createNewEntity("GisWherePlaceHolderValue");
            };
            MapConfigurationService.prototype.createGeometryFilter = function () {
                return this.createNewEntity("GeometryFilter");
            };
            MapConfigurationService.prototype.createQueryGridConfiguration = function () {
                return this.createNewEntity("QueryGridConfiguration");
            };
            MapConfigurationService.prototype.createIncludedQueryField = function () {
                return this.createNewEntity("IncludedQueryField");
            };
            MapConfigurationService.prototype.createQueryGridQuery = function () {
                return this.createNewEntity("QueryGridQuery");
            };
            MapConfigurationService.prototype.createQueryGridFieldMapping = function () {
                return this.createNewEntity("GisFieldMapping");
            };
            MapConfigurationService.prototype.createGisActionBlock = function () {
                return this.createNewEntity("GisActionBlock");
            };
            MapConfigurationService.prototype.createFilterAttribute = function () {
                return this.createNewEntity("FilterAttribute");
            };
            MapConfigurationService.prototype.createAddFeaturesConfiguration = function () {
                return this.createNewEntity("AddFeaturesConfiguration");
            };
            MapConfigurationService.prototype.createDrawFeatureConfiguration = function () {
                var drawFeatureConfiguration = this.createNewEntity("DrawFeatureConfiguration");
                drawFeatureConfiguration.drawStyle = this.createDrawStyle();
                drawFeatureConfiguration.drawingType = 3 /* LineString */;
                drawFeatureConfiguration.clearDrawingAfterSelection = false;
                return drawFeatureConfiguration;
            };
            MapConfigurationService.prototype.createTrimConfiguration = function () {
                return this.createNewEntity("TrimConfiguration");
            };
            MapConfigurationService.prototype.createGisActionCalculationConfiguration = function () {
                return this.createNewEntity("GisActionCalculationConfiguration");
            };
            MapConfigurationService.prototype.createFilterFeatureCollectionConfiguration = function () {
                return this.createNewEntity("FilterFeatureCollectionConfiguration");
            };
            MapConfigurationService.prototype.createValidationConfiguration = function () {
                return this.createNewEntity("GisActionValidationConfiguration");
            };
            MapConfigurationService.prototype.creatSetPropertyConfiguration = function () {
                return this.createNewEntity("SetPropertyConfiguration");
            };
            MapConfigurationService.prototype.createGisDatastoreQueryConfiguration = function () {
                return this.createNewEntity("GisDatastoreQueryConfiguration");
            };
            MapConfigurationService.prototype.createGisActionWorkflowConfiguration = function () {
                return this.createNewEntity("GisActionWorkflowConfiguration");
            };
            MapConfigurationService.prototype.createJavascriptTransformer = function () {
                return this.createNewEntity("JavascriptTransformer");
            };
            MapConfigurationService.prototype.createGisInputOutput = function () {
                return this.createNewEntity("GisInputOutput");
            };
            MapConfigurationService.prototype.createGisInputOutputCollection = function () {
                return this.createNewEntity("GisInputOutputCollection");
            };
            MapConfigurationService.prototype.createGisActionBlockEsriQueryConfiguration = function () {
                return this.createNewEntity("GisActionBlockEsriQueryConfiguration");
            };
            MapConfigurationService.prototype.createLineTrimAttribute = function () {
                return this.createNewEntity("LineTrimAttribute");
            };
            MapConfigurationService.prototype.createBufferConfiguration = function () {
                return this.createNewEntity("BufferConfiguration");
            };
            MapConfigurationService.prototype.createFeatureAttributeToPropertyMap = function () {
                return this.createNewEntity("FeatureAttributeToPropertyMap");
            };
            MapConfigurationService.prototype.createDrawStyle = function () {
                var drawStyle = this.createNewEntity("DrawStyle");
                drawStyle.stroke = true;
                drawStyle.color = '#3388ff';
                drawStyle.weight = 3;
                drawStyle.opacity = 1;
                drawStyle.fill = true;
                drawStyle.fillColor = '#3388ff';
                drawStyle.fillOpacity = 0.2;
                return drawStyle;
            };
            MapConfigurationService.prototype.createZoomToQueryConfiguration = function () {
                var returnObj = this.createNewEntity("ZoomToQueryConfiguration");
                returnObj.highlightZoomResults = false;
                return returnObj;
            };
            return MapConfigurationService;
        }(services.DataService));
        services.MapConfigurationService = MapConfigurationService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService('MapConfigurationService', ['breeze', '$q', '$http']);
